import {Component, OnInit} from '@angular/core';
import {LanguageService} from '../../../services/languages/language.service';
import {NavBarService} from '../../../services/nav-bar/nav-bar.service';

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss']
})
export class PolicyComponent implements OnInit {


  constructor(public ls: LanguageService, private nav: NavBarService) {
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.nav.deselectAll();
      this.nav.policySelected = true;
    }, 0);
  }
}
